import * as checkoutApi from './checkout-api.js';

let analyser = null;
let dataArray = null;
let duration = 0;
let recorder = null;
let source = null;
let stream = null;

export async function initRecorder() {
    destroy();

    const s = await navigator.mediaDevices.getUserMedia({ audio: true });

    stream = s;

    recorder = window.RecordRTC(stream, {
        bufferSize: 16384,
        disableLogs: true,
        numberOfAudioChannels: 2,
        onTimeStamp: (timestamp, timestamps) => {
            duration = Math.floor((new Date().getTime() - timestamps[0]) / 1000);
        },
        sampleRate: 44100,
        timeSlice: 1000,
        type: 'audio',
    });

    const audioCtx = new AudioContext();

    analyser = audioCtx.createAnalyser();
    source = audioCtx.createMediaStreamSource(stream);
    source.connect(analyser);
    analyser.fftSize = 32;
    dataArray = new Uint8Array(analyser.frequencyBinCount);
}

export function start(callback) {
    recorder.startRecording();
    if (callback) callback();
}

export function stop(callback) {
    recorder.stopRecording(() => {
        const blob = recorder.getBlob();

        destroy();

        if (callback) callback(blob);
    });
}

export function destroy() {
    analyser = null;
    dataArray = null;
    duration = 0;

    if (recorder) { recorder.destroy(); recorder = null; }
    if (stream) { stream.getTracks().forEach(t => t.stop()); stream = null; }
    if (source) { source.disconnect(); source = null; }
}

export function getDuration() {
    return duration;
}

export function getAudioData() {
    if (analyser && dataArray) {
        analyser.getByteFrequencyData(dataArray);
    }

    return dataArray || new Uint8Array(0);
}

export async function uploadAndSave(checkoutSessionId, voucherKey, audioBlob) {
    return checkoutApi.uploadAudioMessage(checkoutSessionId, voucherKey, audioBlob);
}
